import React, { useState } from "react";
import { motion } from "framer-motion";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import Logo from "../../assets/Logo.png";
import sefasoft from "../../assets/sefasoft.png";
import { Link } from "react-router-dom";

const NavbarMenu = [
  { id: 1, title: "Accueil", path: "/" },
  { id: 2, title: "Offres d'emploi", path: "/emplois" },
  { id: 3, title: "Inscription", path: "/register" },
  { id: 4, title: "Se connecter", path: "/login" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="absolute top-0 left-0 w-full z-50">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="container mx-auto flex justify-between items-center py-4 px-6 md:px-20 bg-white/10 backdrop-blur-md border-b border-white/20 rounded-2xl shadow-md mt-4 relative"
      >
        <div className="flex items-center gap-2">
          <img
            src={sefasoft}
            alt="sefasoft"
            className="h-8 sm:h-10 w-auto object-contain"
          />
        </div>

        {/* Desktop menu */}
        <div className="hidden lg:block">
          <ul className="flex items-center gap-4 text-gray-500 font-medium tracking-wide">
            {NavbarMenu.map((menu) => (
              <li key={menu.id}>
                {menu.path === "/login" ? (
                  <button
                    type="button"
                    onClick={() => {
                      window.location.href = "/login";
                      setOpen(false);
                    }}
                    className="relative py-2 px-3 hover:text-primary transition duration-300 group"
                  >
                    {menu.title}
                    <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-[#5a46e0] group-hover:w-full transition-all duration-300"></span>
                  </button>
                ) : (
                  <Link
                    to={menu.path}
                    className="relative py-2 px-3 hover:text-primary transition duration-300 group"
                    onClick={() => setOpen(false)}
                  >
                    {menu.title}
                    <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-[#5a46e0] group-hover:w-full transition-all duration-300"></span>
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>

        <div className="hidden md:flex items-center">
          <img src={Logo} alt="Logo" className="h-10 w-auto object-contain" />
        </div>

        {/* Mobile toggle */}
        <div className="lg:hidden z-50">
          <button onClick={() => setOpen(!open)}>
            {open ? (
              <IoMdClose size={28} className="text-gray-500" />
            ) : (
              <IoMdMenu size={28} className="text-gray-500" />
            )}
          </button>
        </div>

        {/* Mobile menu */}
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className="absolute top-full left-0 w-full bg-white/60 backdrop-blur-md rounded-b-2xl shadow-md p-4 lg:hidden"
          >
            <ul className="flex flex-col items-center gap-4 text-gray-500 font-medium">
              {NavbarMenu.map((menu) => (
                <li key={menu.id}>
                  {menu.path === "/login" ? (
                    <button
                      type="button"
                      onClick={() => {
                        window.location.href = "/login";
                        setOpen(false);
                      }}
                      className="hover:text-secondary transition duration-300"
                    >
                      {menu.title}
                    </button>
                  ) : (
                    <Link
                      to={menu.path}
                      className="hover:text-secondary transition duration-300"
                      onClick={() => setOpen(false)}
                    >
                      {menu.title}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </motion.div>
        )}
      </motion.div>
    </nav>
  );
};

export default Navbar;
